export default (numbers): string => {
  let ddd;
  let firstNumbers;
  let secondNumbers;

  const newNumbers = numbers.replace(/[^\d]/g, "");

  if (newNumbers.length === 11) {
    ddd = newNumbers.substring(0, 2);
    firstNumbers = newNumbers.substring(2, 7);
    secondNumbers = newNumbers.substring(7, 11);
    return `(${ddd}) ${firstNumbers}-${secondNumbers}`;
  }

  return numbers;
};
